export default "__VITE_ASSET__C8IgXq3u__"